import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function AlertDialog({ data, callBackAlert }) {
  const [open, setOpen] = React.useState(true);

  return (
    <div>
      <Dialog
        open={data !== null}
        onClose={callBackAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {data && data.message}
        </DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions>
          <Button onClick={callBackAlert} color="primary">
            Done
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
